import React from 'react';
import MaintenanceLayout from '../Components/ErrorPage/MaintenanceLayout';
import { maintenanceConfigs } from '../Components/ErrorPage/maintenanceConfig';

interface Props {
  step?: number;
}

const MaintenancePage = (props: Props) => {
  const { step } = props;
  const config = maintenanceConfigs.default;
  
  return (
    <MaintenanceLayout
      title={config.title}
      description={config.description}
      buttonText={config.buttonText}
      buttonLink={config.buttonLink}
      showNavbar={config.showNavbar}
      showAppStoreButtons={config.showAppStoreButtons}
      step={step}
      className="bg-bgMaintenance bg-cover h-screen bg-no-repeat"
    />
  );
};

export default MaintenancePage;